import React, { useState } from 'react';
import styled from 'styled-components';
import MapboxMap from './MapboxMap';
import { colors } from '../theme';

const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 180px);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  
  @media (max-width: 768px) {
    height: 50vh;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-size: 1.2rem;
  color: #E31B23;
  font-weight: 500;
  backdrop-filter: blur(4px);
  
  &::before {
    content: '';
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #E31B23;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const MapView = ({ days, onAddActivity }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleMapLoad = () => {
    setLoading(false);
  };

  const handleMapError = (error) => {
    console.error('Map error:', error);
    setError('Failed to load map. Please try again later.');
    setLoading(false);
  };

  // Handle adding an activity from the map
  const handleAddActivity = (activity) => {
    onAddActivity(activity);
  };

  return (
    <>
      <div style={{ 
        padding: '0.5rem 1rem',
        marginBottom: '0.75rem',
        borderRadius: '8px',
        background: 'linear-gradient(90deg, #E31B23, #FFD700, #006E33)',
        color: 'white',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ 
          margin: 0, 
          fontSize: '1.1rem', 
          fontWeight: 600,
          lineHeight: '1.3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem'
        }}>
          <span>Explore Portugal</span>
          <span style={{ fontSize: '0.9rem', opacity: 0.9, fontWeight: 400 }}>•</span>
          <span style={{ fontSize: '0.9rem', opacity: 0.9, fontWeight: 400 }}>
            Click on markers to add to your itinerary
          </span>
        </h2>
      </div>
      
      <MapContainer>
        {loading && <LoadingOverlay>Loading Portugal Map...</LoadingOverlay>}
        {error ? (
          <div style={{ 
            padding: '20px', 
            color: '#E31B23',
            background: '#FFEBEE',
            borderRadius: '8px',
            margin: '10px',
            textAlign: 'center',
            fontWeight: 500
          }}>
            {error}
          </div>
        ) : (
          <MapboxMap 
            days={days} 
            onAddActivity={handleAddActivity}
            onLoad={handleMapLoad}
            onError={handleMapError}
          />
        )}
      </MapContainer>
    </>
  );
};

export default MapView;
